export default __webpack_public_path__ + "static/media/favorite_border-24px.caaea4ca.svg";